import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
/**
 * Represents the default `toggleButton` component rendered by the [KendoReact Scheduler DatePicker]({% slug overview_datepicker %}).
 */
export var ToggleButton = React.forwardRef(function (props, ref) {
    var className = classNames('k-select', props.className);
    return (React.createElement("a", { ref: ref, id: props.id, role: "button", style: props.style, className: className, tabIndex: props.tabIndex, title: props.title, "aria-label": props.title, onMouseDown: props.onMouseDown, onClick: props.onClick, onMouseUp: props.onMouseUp }, props.children));
});
//# sourceMappingURL=ToggleButton.js.map